<template>
  <sui-page>
   <sui-page-header :pageId="this.$options.name"/>
    <sui-page-contents>
    <div class="mrR30"></div>

       <div class="inbox brdG01 pd20" style="height:250px;overflow-y:auto">
          <sui-tree
          ref="tree"     
          :noDots="true"
          :wholeRow="true"
          :editable="false"
          v-bind="defaultFdpTreeData"
          @item-click="onItem($event)"></sui-tree>
       </div>

      <div class="mrT30"></div>
      <div class="inbox">
       <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_UPP_DOM_CLS')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" v-model="upperDomainClassId" :disabled="true" placeholder=""/>
            <div class="comp_spacing"></div>
            <sui-text-field max-length="100" v-model="upperDomainClassName" :disabled="true" placeholder=""/>
          </div>
       
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DOM_CLSF_NM')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" v-model="domainClassName" :disabled="true" placeholder=""/>
            <div class="comp_spacing"></div>
         </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DOM_CLSF_ID')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" v-model="domainClassId" :disabled="true" placeholder=""/>
            <div class="comp_spacing"></div>
          </div>
        
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DOM_PHSC_NM')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" v-model="domainId" :disabled="true" placeholder=""/>
            <div class="comp_spacing"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DOMAIN_NAME')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" v-model="domainName" :disabled="true" placeholder=""/>
            <div class="comp_spacing"></div>
          </div>
          <div class="col-xs-1"/>
          <div class="col-xs-5"/>
        </div>
        </div>
       </div>
    
        <div class="comm_btn_wrap">
		      <sui-button type="button" class="comm_btn_border" @click="onCancel">{{$t('MSG_BTN_CANCEL')}}</sui-button>
		      <sui-button type="button" class="comm_btn_solid"  @click="onClickSelectWord">{{$t('MSG_BTN_SELT')}}</sui-button>
		    </div>
  </sui-page-contents>

</sui-page>
</template>
<script>
 export default {
    name: 'PGE_CMT_00014',
    props: {
      closePagePopup: {
        type: Function,
      },
    },
    data() {
       return {
         selectedCodeValue: {
            COD_MDLE: {
              label: '',
              key: ''
          }
        },
        upperDomainClassId : '',
        upperDomainClassName : '',
        domainClassName: '',
        domainClassId: '',
        selectedWord: '',
        domainName: '',
        domainId:'',
        dataStandardId:'',
        dataStandardName: '',
        dataStandardParentId: '',
        domainTreeLevel: '',
        defaultFdpTreeData: {
        data: [{
          id: '',
          parentId: '',
          folderYn: 'Y',
          level: 0,
          value: this.$t(''),
          text: this.$t(''),
          opened: true,
          children: [],
        }],
      },

        localdata0: [
          ['word name', 'word name(EN)', 'word content'],
          ['word name', 'word name(EN)', 'word content'],
          ['word name', 'word name(EN)', 'word content'],
          ['word name', 'word name(EN)', 'word content'],
          ['word name', 'word name(EN)', 'word content']
          ],
        gridColumns0: [{
          text: this.$t('MSG_TXT_WRD_NM'),
          datafield: 'datafield0'
        }, {
          text: this.$t('MSG_TXT_WRD_EN_NM'),
          datafield: 'datafield1'
        }, {
          text: this.$t('MSG_TXT_WRD_DSCR'),
          datafield: 'datafield2'
        }],
      };
    },
    computed: {},
    watch: {},
    // datasets: [],
    mounted() {
      http.request('PGE_CMT_00014', 'DTS_CMT_00015',{
      }).then((res) => {
        const myTreeData= res.data;
        this.setTreeData(res.data);
        
        this.defaultFdpTreeData.data.forEach(child => {
          child.children.forEach(item_lv1 => {
            item_lv1.opened = false;
          })
        });
      })
      .catch((error) => {
      console.log(error);

      });
    },

    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {

      setTreeData(data) {
        const treeMap = {};
        const rootNode = {
          id: 'root',
          parentId: null,
          level: 0,
          folderYn: 'Y',
          value: this.$t(''),
          text: this.$t(''),
          opened: true,
          children: [],
        };

        rootNode.children = utils.getMakeTreeData({
          id: 'dataStandardId',
          parentId: 'dataStandardParentId',
          level: 'domainTreeLevel',
          value: 'dataStandardName',
          text: '{{dataStandardName}} ({{dataStandardId}})',
        }, data, true);
         this.defaultFdpTreeData = { data: [rootNode] };
      },
       onClickSelectWord() {
           this.closePagePopup(this.selectedWord)
           //this.onPopupCancelClicked();
       },

      onCancel(){
        this.closePagePopup(false);
      },
      onPopupCancelClick() {
        this.$emit('exit',true);
      },
      onItem(e) {
          this.selectedWord = e.data;
          this.upperDomainClassName = e.data.upperDomainClassificationName;
          this.upperDomainClassId = e.data.upperDomainClassificationID;
          this.domainClassName = e.data.domainClassificationName;
          this.domainClassId = e.data.domainClassificationID;
          this.domainClassLevel = e.data.domainClassificationLevel;
          this.domainName = e.data.domainName;
          this.domainId = e.data.domainId;
          this.dataStandardId = e.data.dataStandardId;
          this.dataStandardName = e.data.dataStandardName;
          this.dataStandardParentId = e.data.dataStandardParentId;
          this.domainTreeLevel = e.data.domainTreeLevel;
      },
    },

    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [ {
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
       }]
    }],
  };
</script>
<style scoped>
</style>